import { CustomColumnModelInterface, TableColumnsSetting } from '@/interfaces/table-setting';
import { InsuranceModel } from '@/models/insurances/insurance.model';
import { AssociationsInsuranceRentPracticeModel } from '@/models/insurances/associations-insurance-rent-practice-model';
import { of } from 'rxjs';

export class ConnectionsInsuranceRentPractice {
  public static getColumnsSetting(): TableColumnsSetting<
    keyof AssociationsInsuranceRentPracticeModel
  > {
    return [
      this.getCustomColumnViewDetail(),
      this.getCustomColumnModifyAssociation(),
      this.getCustomColumnPause(),
      this.getCustomColumnActive(),
      {
        name: 'statoAssociazione',
        text: 'Stato',
        filter: {
          type: 'select',
          options: of([{ ATTIVA: 'ATTIVA' }, { SOSPESA: 'SOSPESA' }, { SCADUTA: 'SCADUTA' }]),
        },
      },
      {
        name: 'tipoPratica',
        text: 'Tipo Pratica',
        filter: {
          type: 'select',
          options: of([{ NUOVO: 'NUOVO' }, { USATO: 'USATO' }]),
        },
      },
      {
        name: 'codicePratica',
        text: 'Codice Pratica',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'targa',
        text: 'Targa',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'numApplicazione',
        text: 'Num. applicazione',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'denominazioneUtilizzatore',
        text: 'Utilizzatore',
      },
      {
        name: 'premioNetto',
        text: 'Premio Netto',
        type: 'currency',
      },
      {
        name: 'dataInizio',
        text: 'Data Inizio',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'dataFine',
        text: 'Data Fine',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }

  private static getCustomColumnPause(): CustomColumnModelInterface {
    return {
      name: 'btnPause',
      index: 2,
      customButton: true,
      unsortable: true,
      condition: (element: AssociationsInsuranceRentPracticeModel) =>
        element.statoAssociazione === 'ATTIVA',
    };
  }

  private static getCustomColumnActive(): CustomColumnModelInterface {
    return {
      name: 'btnActive',
      index: 3,
      customButton: true,
      unsortable: true,
      condition: (element: AssociationsInsuranceRentPracticeModel) =>
        element.statoAssociazione === 'SOSPESA' || element.statoAssociazione === 'BOZZA',
    };
  }

  private static getCustomColumnViewDetail(): CustomColumnModelInterface {
    return {
      name: 'btnViewDetail',
      index: 1,
      customButton: true,
      unsortable: true,
      condition: (element: AssociationsInsuranceRentPracticeModel) => true,
    };
  }

  private static getCustomColumnModifyAssociation() {
    return {
      name: 'btnModifyAssociation',
      index: 0,
      customButton: true,
      unsortable: true,
      condition: (element: AssociationsInsuranceRentPracticeModel) => true,
    };
  }
}
